import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=49c0c964&scoped=true&"
import script from "./uploadFile.vue?vue&type=script&lang=js&"
export * from "./uploadFile.vue?vue&type=script&lang=js&"
import style0 from "./uploadFile.vue?vue&type=style&index=0&id=49c0c964&prod&lang=css&"
import style1 from "./uploadFile.vue?vue&type=style&index=1&id=49c0c964&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c0c964",
  null
  
)

export default component.exports